<template>
    <v-card-text>
        <v-row class="ui-value-row">
            <v-col cols="2">&nbsp;</v-col>
            <v-col :cols="col1Width" class="coltext">
                <v-list-item-title class="coltext-el">
                    <span class="text">{{ this.title }}</span>
                </v-list-item-title>
                <v-list-item class="coltext-el ui-value">
                    <span class="text-h4" v-if="!isLargeValue">{{ this.value }}</span>
                    <span class="text-h5" v-if="isLargeValue">{{ this.value }}</span>
                    <span class="ui-um">{{ this.um }}</span>
                </v-list-item>
                <v-list-item class="ui-updated-at">
                    {{ this.updatedAt }}
                </v-list-item>
            </v-col>
            <v-col class="icon-container" :cols="col2Width" v-if="hasIcon">
                <v-img v-if="this.img" :src="this.img" alt="Icon" :width="iconWidth"></v-img>
                <v-icon v-if="this.icon" :size="iconWidth">{{ this.icon }}</v-icon>
            </v-col>
        </v-row>
    </v-card-text>
</template>

<script>
export default {
    name: "UiValue",

    props: {
        title: String,
        value: String,
        um: String,
        icon: String,
        img: String,
        updatedAt: String,
    },

    components: {
    },

    data: function () {
        return {
            iconWidth: 30
        };
    },

    created: function () {
        //this.value = 99.999;
    },

    mounted: function () {

    },

    computed: {
        col1Width() {
            return 7;
        },
        col2Width() {
            return 2;
        },
        hasIcon() {
            return true;
        },
        isLargeValue() {
            return this.value.toString().length > 5;
        }
    },

    afterCreate: function () { },

    beforeCreate: function () { },

    beforeDestroy: function () {

    },

    methods: {
    },
};
</script>

<style scoped>
.list-item-value {
    color: #999999;
    font-size: 12px;
}

.v-list-item__title {
    color: #666666;
    font-size: 13px;
}

/* .sublist.v-list-item .image {
    padding-top: 20px;
} */

.icon-container {
    margin-top: 27px;
}

.ui-updated-at {
    font-size: 11px;
}

.coltext-el,
.ui-updated-at {
    text-align: center;
    border: 0 auto;
    display: block;
}

.ui-value-row {
    height: 100px;
}

.ui-value {}
</style>
